import React, {useState, useEffect} from 'react'
import './AudioManager.scss';

const AudioManager = props => {
    const [audioElements, setAudioElements] = useState([]);
    const [currentLocation, setCurrentLocation] = useState({
        step:-1,
        gesture:-1,
    });

    const isCurrentLocation = (currentLocation.step === props.stepIndex) && (currentLocation.gesture === props.gestureIndex)


    const pushAudio = (data) => {
        if(data.path === '') return;
        const audioOnPage = document.querySelectorAll('audio');
        audioOnPage.forEach(audio => {
            audio.pause();
        })
        setAudioElements([...audioElements, 
            <audio controls={true} autoPlay={true} key={`s${props.stepIndex}g${props.gestureIndex}-${data.path}`}>
                <source src={data.path} type="audio/mpeg"/>
            </audio>])  
        setCurrentLocation({
            step:props.stepIndex,
            gesture:props.gestureIndex,
        })      
    }

    useEffect(()=>{
        if(props.currentGesturedata && !isCurrentLocation && !props.introOpen && props.currentGestureData.audio){
            pushAudio(props.currentGestureData.audio)
        }
    }, [props.currentGestureData, props.introOpen])

    return (
        <div className="AudioManager">
            {audioElements}
        </div>
    )
}

export default AudioManager